import Reveal from "@/components/Reveal";
import { STATS, SERVICE_AREA } from "@/data/content";

export default function About() {
  return (
    <section data-testid="about-section" className="bg-rc-bg py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal trackLabel="about">
            <div className="font-mono text-rc-red text-xs uppercase tracking-[0.3em] mb-5">01 — Who We Are</div>
            <h2 className="font-heading font-black text-rc-blue leading-[0.95] text-[clamp(2rem,4.5vw,3.5rem)] tracking-tight">
              A premier Florida road building & asphalt contractor.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-rc-brown text-lg leading-relaxed">
              Ranger Construction specializes in road building and asphalt production for both public and private
              sectors. Every project is carried out by highly skilled crews dedicated to exceptional standards of
              quality and safety.
            </p>
            <p className="mt-5 text-rc-brown/80 leading-relaxed">{SERVICE_AREA}</p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="grid grid-cols-2 gap-px bg-black/10 border border-black/10">
          {STATS.map((s) => (
            <div
              key={s.label}
              data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-rc-bg px-2 py-6 sm:p-8 lg:p-10 group hover:bg-rc-charcoal transition-colors duration-300"
            >
              <div className="font-heading font-black text-rc-red text-4xl sm:text-5xl lg:text-6xl group-hover:text-rc-sand transition-colors">
                {s.value}
              </div>
              <div className="mt-3 font-mono text-xs uppercase tracking-normal sm:tracking-[0.18em] text-rc-charcoal group-hover:text-white/70 transition-colors">
                {s.label}
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
